import { CommunityView } from '@lumapps/communities/constants';
import { COMMUNITIES } from '@lumapps/communities/keys';
import { mdiCalendar, mdiFolderGoogleDrive, mdiHome, mdiMessageTextOutline } from '@lumapps/lumx/icons';
import { NavigationItemType } from '@lumapps/navigation/types';
import { GLOBAL } from '@lumapps/translations';

import { type StaticNavigationItem } from './types';

export const MAX_DEPTH = 2;
export const MAX_WIDTH = 50;
export const WIDTH_WARNING = 10;

export const ACCEPTED_NAVIGATION_ITEM_TYPES = [
    NavigationItemType.ROOT,
    NavigationItemType.PAGE,
    NavigationItemType.LINK,
    NavigationItemType.SECTION,
];

/**
 * List of all the Community pages available in the navigation.
 * Order is important, entries will be displayed in that order of priority.
 * */
export const COMMUNITY_SERVICE_RECORD: Record<
    Exclude<keyof typeof CommunityView, 'home' | 'post'>,
    Omit<StaticNavigationItem, 'to'>
> = {
    [CommunityView.dashboard]: {
        view: CommunityView.dashboard,
        label: COMMUNITIES.DASHBOARD,
        icon: mdiHome,
    },
    [CommunityView.posts]: {
        view: CommunityView.posts,
        label: GLOBAL.POSTS,
        icon: mdiMessageTextOutline,
    },
    [CommunityView.events]: {
        view: CommunityView.events,
        label: GLOBAL.EVENTS,
        icon: mdiCalendar,
    },
    [CommunityView.media]: {
        view: CommunityView.media,
        label: GLOBAL.DRIVE,
        icon: mdiFolderGoogleDrive,
    },
    [CommunityView.calendar]: {
        view: CommunityView.calendar,
        label: GLOBAL.CALENDAR,
        icon: mdiCalendar,
    },
};
